import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { BaseMapId } from '../utils/basemaps'

type Ctx = {
  baseId: BaseMapId
  setBaseId: (id: BaseMapId) => void
}

const BaseMapContext = createContext<Ctx | undefined>(undefined)

export function BaseMapProvider({ children }: { children: React.ReactNode }) {
  const [baseId, setBaseId] = useState<BaseMapId>(() => (localStorage.getItem('basemap') as BaseMapId) || 'osm')

  useEffect(() => {
    try { localStorage.setItem('basemap', baseId) } catch {}
  }, [baseId])

  const value = useMemo(() => ({ baseId, setBaseId }), [baseId])
  return <BaseMapContext.Provider value={value}>{children}</BaseMapContext.Provider>
}

export function useBaseMap(): Ctx {
  const ctx = useContext(BaseMapContext)
  if (!ctx) throw new Error('useBaseMap must be used within BaseMapProvider')
  return ctx
}

